import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import {
  getFavoriteContentWithHighestRank,
  getMprdProductType,
  hasEligibleFavoriteContent,
  Option,
  Product,
} from '@dch/products-business-logic';
import { LanguageService } from '@proximus/ng-common';
import { savePii } from '../../../../shared/pii/pii.utils';

@Component({
  selector: 'mprd-tv-bonus',
  templateUrl: './tv-bonus.component.html',
})
export class TvBonusComponent implements OnChanges {
  @Input()
  product: Product;
  anyTvBonusWithFavContentMessage: Option;
  tvBonusDiscountText: string;
  tvBonusEligible: boolean;
  productType: string;

  savePii = savePii;

  constructor(
    private element: ElementRef,
    private languageService: LanguageService,
  ) {}

  ngOnChanges() {
    this.tvBonusEligible =
      this.product &&
      (hasEligibleFavoriteContent(this.product) ||
        !!getFavoriteContentWithHighestRank(this.product));
    if (this.tvBonusEligible) {
      this.anyTvBonusWithFavContentMessage =
        this.product &&
        this.product.options &&
        this.product.options.find((o: Option) => o.favContentMessage);
      this.productType = this.product && getMprdProductType(this.product);
      this.tvBonusDiscountText =
        this.anyTvBonusWithFavContentMessage &&
        this.anyTvBonusWithFavContentMessage.favContentMessage !== undefined
          ? this.anyTvBonusWithFavContentMessage.favContentMessage[
              this.languageService.getSelectedLanguage() || 'en'
            ]
          : undefined;
    }
  }
}
